module.exports = __webpack_public_path__ + "static/media/new-icon.84acf2ae.png";